import { useEffect } from 'react';
import type { ReactElement, ReactNode } from 'react';

import { installScreenMetrics } from '@/utils/screenUtil';

import { LoadingOverlayHost } from './loading/LoadingOverlayHost';
import { SnackbarHost } from './snackbar/SnackbarHost';

/**
 * Перенос `lib/src/presentation/widgets/app_wrappers/app_settings_wrapper.dart`.
 *
 * Во Flutter обёртка делала три вещи:
 *   * `ScreenUtilInit(designSize: ...)` — здесь это `installScreenMetrics`,
 *     который сам следит за размером окна и ставит `--sw`/`--sh`
 *     и `data-orientation` на `:root`;
 *   * `MediaQuery(textScaler: ...)` — в браузере системного масштаба текста
 *     нет, размеры шрифтов и так в CSS-пикселях, поэтому слой не нужен;
 *   * `ToastificationWrapper(config: ...)` — его роль играет `SnackbarHost`,
 *     в нём же живут ширина 700.w и ограничения на число строк.
 *
 * `LoadingOverlayHost` заменяет `EasyLoading.init()` из `main.dart`:
 * оверлею тоже нужна одна точка монтирования над всем деревом.
 */
export interface AppSettingsWrapperProps {
  children: ReactNode;
}

export function AppSettingsWrapper({ children }: AppSettingsWrapperProps): ReactElement {
  // Возвращаем функцию отписки — это `dispose` у ScreenUtilInit.
  useEffect(() => installScreenMetrics(), []);

  return (
    <>
      {children}
      <SnackbarHost />
      <LoadingOverlayHost />
    </>
  );
}
